import React from "react";

// Custom SVG Instagram Logo
const InstagramIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="w-8 h-8 text-white transition-transform duration-300 transform group-hover:scale-110"
  >
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
  </svg>
);

const InstagramFeed = () => {
  // 6 cards exactly matching the screenshot sequence
  const feedItems = [
    {
      imgUrl: "https://images.unsplash.com/photo-1563379091339-03b21ab4a4f8?w=600&auto=format&fit=crop&q=80",
      alt: "Pasta with meatballs and tomatoes"
    },
    {
      imgUrl: "https://images.unsplash.com/photo-1513104890138-7c749659a591?w=600&auto=format&fit=crop&q=80",
      alt: "Lifting cheesy pizza slice"
    },
    {
      imgUrl: "https://images.unsplash.com/photo-1498837167922-ddd27525d352?w=600&auto=format&fit=crop&q=80",
      alt: "Fresh salad plate and orange juice"
    },
    {
      imgUrl: "https://images.unsplash.com/photo-1563379091339-03b21ab4a4f8?w=600&auto=format&fit=crop&q=80",
      alt: "Pasta with meatballs and tomatoes"
    },
    {
      imgUrl: "https://images.unsplash.com/photo-1513104890138-7c749659a591?w=600&auto=format&fit=crop&q=80",
      alt: "Lifting cheesy pizza slice"
    },
    {
      imgUrl: "https://images.unsplash.com/photo-1498837167922-ddd27525d352?w=600&auto=format&fit=crop&q=80",
      alt: "Fresh salad plate and orange juice"
    }
  ];

  // Double the list to make the loop infinite and seamless
  const repeatedItems = [...feedItems, ...feedItems];

  return (
    <section className="w-full bg-[#f5f2eb] overflow-hidden select-none relative z-10 border-t-8 border-[#f5f2eb]">
      {/* Inline styles for the horizontal scrolling marquee */}
      <style
        dangerouslySetInnerHTML={{
          __html: `
        @keyframes feed-marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-feed-marquee {
          display: flex;
          width: max-content;
          animation: feed-marquee 35s linear infinite;
        }
        .group-hover-pause:hover .animate-feed-marquee {
          animation-play-state: paused;
        }
      `,
        }}
      />

      {/* Main Container */}
      <div className="w-full overflow-hidden flex items-center group group-hover-pause">
        <div className="animate-feed-marquee flex items-center">
          {repeatedItems.map((item, idx) => (
            <div
              key={idx}
              className="relative w-56 sm:w-72 md:w-80 lg:w-[350px] aspect-square flex-shrink-0 border-r-8 border-[#f5f2eb] overflow-hidden group/item cursor-pointer"
            >
              {/* Food Image */}
              <img
                src={item.imgUrl}
                alt={item.alt}
                className="w-full h-full object-cover transition-transform duration-500 group-hover/item:scale-105"
                loading="lazy"
              />

              {/* Instagram Hover Overlay */}
              <div className="absolute inset-0 bg-black/50 opacity-0 group-hover/item:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                <div className="bg-black/30 p-4 rounded-full border border-white/20 backdrop-blur-xs">
                  <InstagramIcon />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InstagramFeed;
